import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';

import { pageChanged } from '../../../../../../data/redux/page_details/actions';
import { getAllAgents, getGroupDetails, createGroup, updateGroup } from '../../../../../../data/redux/member_details/actions';

import { APP_PAGES, APP_LAYOUT, ROUTE_PATH } from '../../../../../../data/config/constants';
import { getUrlParams, showMessage } from '../../../../../../data/config/utils';

import CustomHeader from '../../../../../../components/customheader';
import GroupForm from '../components/groupform';
import GroupDetailCard from '../components/groupdetailcard';
import ErrorBoundary from '../../../../../../components/errorboundary';

class AddAndEditGroup extends React.PureComponent {
  state = {
    group: {}
  };

  componentDidMount() {
    const { agents, actions, history } = this.props;
    if (agents.length === 0) {
      actions.getAllAgents();
    }
    if (history.location.pathname === ROUTE_PATH.ADD_GROUP) {
      actions.pageChanged(APP_PAGES.ADD_GROUP, APP_PAGES.MEMBERS);
    }
    if (history.location.pathname === ROUTE_PATH.EDIT_GROUP) {
      actions.pageChanged(APP_PAGES.EDIT_GROUP, APP_PAGES.MEMBERS);
      const params = getUrlParams();
      if (params && params.name) {
        const payload = { name: params.name };
        actions.getGroupDetails(payload, (error, group) => {
          if (!error) {
            this.setState({ group });
          } else {
            this.goBackToGroups();
          }
        });
      } else {
        showMessage('error', 'groupid is missing in params');
        this.goBackToGroups();
      }
    }
  }

  goBackToGroups = () => {
    const { history } = this.props;
    history.push(ROUTE_PATH.GROUPS);
  };

  updateGroup = (key, value) => {
    this.setState({
      group: {
        ...this.state.group,
        [key]: value
      }
    })
  };

  onChangeName = event => {
    this.updateGroup('name', event.target.value);
  };

  onChangeDescription = event => {
    this.updateGroup('description', event.target.value);
  };

  onChangeMembers = members => {
    this.updateGroup('agents', members);
  };

  onClickSaveGroup = () => {
    const { actions, history } = this.props;
    const { group } = this.state;
    const agents_id = [];
    if (group && group.agents) {
      for (let i = 0; i < group.agents.length; i++) {
        agents_id[i] = group.agents[i]._id;
      }
    }
    const payload = {
      ...group,
      agents: agents_id
    }
    if (history.location.pathname === ROUTE_PATH.ADD_GROUP) {
      actions.createGroup(payload, this.goBackToGroups);
    }
    if (history.location.pathname === ROUTE_PATH.EDIT_GROUP) {
      actions.updateGroup(payload, this.goBackToGroups);
    }
  };

  render() {
    const { screen_height, screen_width, agents, history } = this.props;
    const { group } = this.state;
    return (
      <div className="ori-lr-pad-10">
        <Row gutter={20}>
          <Col xs={24} sm={16} md={18}>
            <CustomHeader title={history.location.pathname === ROUTE_PATH.ADD_GROUP ? "Add Group" : "Edit Group"} first_button_type="primary" onClickFirstButton={this.onClickSaveGroup} onClickSecondButton={this.goBackToGroups} bottom_bordered show_first_button show_second_button />
            <Row>
              <Col xs={24} sm={{ span: 22, offset: 1 }} md={{ span: 16, offset: 4 }} className="ori-t-pad-20">
                <ErrorBoundary>
                  <GroupForm screen_width={screen_width} group={this.state.group} agents={agents} onChangeName={this.onChangeName} onChangeDescription={this.onChangeDescription} onChangeMembers={this.onChangeMembers} />
                </ErrorBoundary>
              </Col>
            </Row>
          </Col>
          <Col xs={24} sm={8} md={6} className="ori-t-pad-20 ori-b-pad-15 ori-l-pad-5 ori-overflow-x-hidden ori-overflow-y-auto" style={{ height: `${screen_height - APP_LAYOUT.APP_HEADER_HEIGHT}px` }}>
            <ErrorBoundary>
              <GroupDetailCard group={group} empty_member_message="No any member." />
            </ErrorBoundary>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    screen_height: state.page_details.device_data.screen_height,
    screen_width: state.page_details.device_data.screen_width,
    agents: state.member_details.agents,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      pageChanged,
      getAllAgents,
      getGroupDetails,
      createGroup,
      updateGroup
    }, dispatch),
  };
};

AddAndEditGroup.propTypes = {
  screen_height: PropTypes.number,
  screen_width: PropTypes.number,
  agents: PropTypes.array,
  actions: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(AddAndEditGroup);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/members/groups/addandeditgroup/index.js